<template>
  <div class="brand-content">
    <yj-list class="brand-view" v-if="categoryData.length > 0" :loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="brand-item" v-for="(item, index) in categoryData" :key="index" @click="goToBrandDetail(item.subjectId)">
        <div class="item-top-sign">
          <img :src="item | signImg">
        </div>
        <yj-count-down class="item-top-sign-countDown" v-if="item.labelType === 0" :time="item.countDown" @finish="countDownFinish(index)">
          <template v-slot="timeData">
            <span>剩</span>
            <span v-if="timeData.days > 0">{{ timeData.days }}</span>
            <span v-if="timeData.days > 0">天</span>
            <span>{{timeData.hours >= 10 ? timeData.hours : `0${timeData.hours}`}}</span>
            <span>:</span>
            <span>{{timeData.minutes >= 10 ? timeData.minutes : `0${timeData.minutes}`}}</span>
            <span>:</span>
            <span>{{timeData.seconds >= 10 ? timeData.seconds : `0${timeData.seconds}`}}</span>
          </template>
        </yj-count-down>
        <div class="item-bgImg">
          <img class="bgImg" :src="item.bgImg">
        </div>
        <div class="item-bottom" :class="{'item-bottom-noSign': item.labelType > 1}">
          <div class="bottom-subitem" v-for="(subItem, subIndex) in item.items" :key="subIndex" @click.stop="goToItemDetail(subItem.itemId)">
            <img :src="subItem.itemImg" class="subItem-itemImg">
            <div class="subItem-itemSign">
              <img class="item-sign-front" src="//static.yunjiglobal.com/qnUpload/frontend/yunji/yj_category_brand_zone_discount_sign.png" >
              <div class="item-sign-val">{{subItem.discountVal}}</div>
            </div>
            <div class="price_box">
              <div class="pb_fx">￥</div>
              <div class="pb_num">{{subItem.itemPrice}}</div>
              <div class="price-vip">￥{{subItem.itemVipPrice}}</div>
            </div>
          </div>
        </div>
      </div>
    </yj-list>
    <NoResult v-else :status="1" @reloadData="reloadData" :isCategory="true"></NoResult>
  </div>
</template>

<script>
import Vue from 'vue'
import { createNamespacedHelpers } from 'vuex'
import { CountDown, List } from '@yunji/h5'
import NoResult from '@/pages/commodity/components/NoResult/NoResult.vue'
import { jumpHandle } from '../util'

const { mapState, mapActions } = createNamespacedHelpers('categoryNav')

Vue.use(CountDown)
Vue.use(List)

export default {
  components: {
    NoResult
  },
  props: ['pageId'],
  data() {
    return {
      historyFootprintIfon: '',
      isRepeat: true
    }
  },
  computed: {
    ...mapState({
      isApp: state => state.isApp,
      appCont: state => state.appCont,
      shopId: state => state.shopId,
      categoryData: state => state.categoryData,
      plName: state => state.parentLevelName,
      resourceId: state => state.resourceId,
      // eslint-disable-next-line no-nested-ternary
      status: state => (state.isReq ? 3 : state.isErr ? 2 : 1),
      loading: state => state.isReq,
      finished: state => state.isFinished
    })
  },
  filters: {
    signImg(item) {
      if (item.labelType === 0) {
        if (item.countDown > 24 * 60 * 60 * 1000) {
          return '//static.yunjiglobal.com/qnUpload/frontend/yunji/yj_category_brand_zone_countdown_large.png'
        }
        return '//static.yunjiglobal.com/qnUpload/frontend/yunji/yj_category_brand_zone_countdown.png'
      }  
      if (item.labelType === 1) {
        return '//static.yunjiglobal.com/qnUpload/frontend/yunji/yj_category_brand_zone_today_brand.png'
      }
      if (item.labelType === 2) {
        // 预热标
        return '//static.yunjiglobal.com/qnUpload/frontend/yunji/yj_category_preheat_icon.png'
      }
      return ''
    }
  },
  mounted() {

  },
  methods: {
    ...mapActions(['queryCategoryName', 'getBrandSaleZoneList']),

    reportClick_list(type, contentId) {
      const params = {
        page_id: '81442',
        point_id: '31854',
        click_type: type == 1 ? '专题' : '商品'
      }
      if (type == 1) {
        params.content_id = contentId  
      } else if (type == 2) {
        params.item_id = contentId
      }
      window.thinkingReport.track('other', params)
    },
    countDownFinish(index) {
      this.categoryData.splice(index, 1)
    },
    goToBrandDetail(brandId) {
      // 专题
      jumpHandle({ jumpType: 1, jumpValue: brandId }, this.appCont)
      this.reportClick_list(1, brandId)
    },
    goToItemDetail(itemId) {
      // 商品
      jumpHandle({ jumpType: 2, jumpValue: itemId }, this.appCont)
      this.reportClick_list(2, itemId)
    },
    // 重新加载数据， 无菜单栏则刷新queryCategoryName接口
    reloadData() {
      if (this.resourceId) {
        this.getBrandSaleZoneList()
      } else {
        this.queryCategoryName()
      }
    },
    onLoad() {
      this.getBrandSaleZoneList()
    }
  }
}

</script>

<style lang="less" scoped>
.brand-content {
  height: 100%;
}
.brand-view {
  padding-top: 0.24rem;
  .brand-item {
    position: relative;
    overflow: hidden;
    padding: 0 0.24rem 0.24rem;
    .item-top-sign {
      position: absolute;
      left: 0.24rem;
      top: 0;
      height: 0.54rem;
      img {
        height: 0.54rem;
      }      
    }
    .item-top-sign-countDown {
      position: absolute;
      left: 0.24rem;
      top: 0;
      height: 0.54rem;
      padding-left: .16rem;
      padding-top: .12rem;
      font-family: PingFangSC-Regular;
      font-size: .24rem;
      color: #FFFFFF;
      line-height: 0.24rem;
      font-weight: 400;
    }
    .item-bgImg {
      width: 100%;
      margin-top: .06rem;
      .bgImg {
        display: block;
        width: 100%;
        min-height: 2rem;
        max-height: 20rem;
        border-radius: .056rem;
      }
    }
    .item-bottom {
      position: absolute;
      left: 0.24rem;
      right: 0.24rem;
      top: 0;
      bottom: 0.24rem;
      background-size: 100%;
      display: flex;
      align-items: flex-end;
      padding: 0 .16rem 0.16rem;
      .bottom-subitem {
        width: 1.6rem;
        height: 1.88rem;
        background: white;
        border-radius: .056rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: .04rem;
        &:not(:first-child) {
          margin-left: .1rem;
        }
        .subItem-itemImg {
          width: 1.28rem;
          height: 1.28rem;
          z-index: 10;
        }
        .subItem-itemSign {
          margin-top: -0.28rem;
          height: 0.28rem;
          z-index: 20;
          display: flex;
          .item-sign-front {
            height: 0.28rem;
          }
          .item-sign-val {
            background-image: linear-gradient(90deg, #FB2269 0%, #EE2532 100%);
            padding: .04rem 0.1rem 0 0.04rem;
            border-radius: 0 0.02rem 0.02rem 0;
            font-family: PingFangSC-Medium;
            font-size: .22rem;
            color: #FFFFFF;
            text-align: center;
            line-height: .22rem;
            font-weight: 500;
            white-space: nowrap;
          }
        }
        .price_box{
          margin-top: .12rem;
          display: flex;
          align-items: center;
          .pb_fx{
            color: #333333;
            font-size: .2rem;
            font-family: PingFangSC-Semibold;
            line-height: .2rem;
            font-weight: 600;
            height: 0.2rem;
            transform: translateY(1px);
          }
          .pb_num{
            font-family: DINAlternate-Bold;
            font-size: .28rem;
            color: #333333;
            display: inline-block;
            line-height: 0.28rem;
          }
          .price-vip {
            font-family: PingFangSC-Regular;
            margin-left: 0.02rem;
            font-size: .18rem;
            color: #666666;
            font-weight: 400;
            line-height: 0.28rem;
            transform: translateY(1px);
            text-size-adjust: none;
            display: inline-block;
            text-decoration:line-through;
          }
        }
      }
    }
    .item-bottom-noSign {
      margin-top: 0;
    }
  }
}
</style>
